import { useContext } from 'react'

import { UserCanUpdateProposalContext } from './UserCanUpdateProposalContext'

export const useUserCanUpdateProposal = () =>
  useContext(UserCanUpdateProposalContext)
